// Nhớ hợp tác xã đã chọn ở lần "Nhập thu mua" gần nhất — chỉ để tự điền sẵn
// cho lượt tiếp theo trên cùng máy/trình duyệt, không đồng bộ giữa các thiết
// bị (khác với bản nháp lưu trên Firestore).

const KHOA = "nho_hop_tac_xa";
// "Đã nhớ là không qua HTX nào" phải phân biệt được với "chưa từng nhớ gì cả"
// — nếu chỉ lưu chuỗi rỗng cho cả 2 trường hợp thì không biết lúc nào nên tự
// tick sẵn ô "Nhớ lựa chọn".
const SENTINEL_KHONG = "__khong_htx__";

export function coHopTacXaDaNho() {
  try {
    return localStorage.getItem(KHOA) != null;
  } catch {
    return false;
  }
}

export function layHopTacXaDaNho() {
  try {
    const gt = localStorage.getItem(KHOA);
    return gt && gt !== SENTINEL_KHONG ? gt : "";
  } catch {
    return "";
  }
}

// maHopTacXa rỗng ("") nghĩa là nhớ rõ ràng "không qua hợp tác xã nào", vẫn
// khác với chưa-từng-nhớ (xem coHopTacXaDaNho).
export function luuHopTacXaDaNho(maHopTacXa) {
  try {
    localStorage.setItem(KHOA, maHopTacXa || SENTINEL_KHONG);
  } catch {
    // localStorage có thể bị chặn (chế độ ẩn danh...) — bỏ qua, không chặn
    // luồng lưu giao dịch chính.
  }
}

export function xoaHopTacXaDaNho() {
  try {
    localStorage.removeItem(KHOA);
  } catch {
    // Bỏ qua cùng lý do trên.
  }
}
